import styled from 'styled-components';
import Colors from '../../../helpers/Colors'
export const TextStyle = styled.h2`
    color: ${Colors.neutral};
    font-size: 2rem;
    font-family: Source Sans Pro
`;

export default TextStyle;